<template>
  <div>
    <div id="fh5co-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <p>
              <small>
                &copy; {{ year }}
                <br />
                <span>Got a crazy idea? I’m in.</span>
                <br />
                <span>Need someone who actually reads logs?</span>
                <br />
                <span>Let’s build something that scales 🚀</span>
                <br />Built by Desta Wiji Pratama with
                <i class="icon-heart" aria-hidden="true"></i>
              </small>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'footerSection',
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
